import moment from "moment";

const momentTime = (timeString) => moment(timeString).format("lll");
export default momentTime;
